/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import loading from './decks/loading.svg'

let decks

const getDecks = () => {
  const placeHolders = (size) => new Array(size).fill(0).map((value, index) => ({ id: index, image: loading }))
  if (!decks) {
    decks = [
      {
        id: 0,
        nlsid: 'decks.deck_0',
        cards: placeHolders(14),
        loaded: false,
        loader: (done) => require.ensure(['./decks/xmas/xmas'],
          (require) => {
            done(require('./decks/xmas/xmas').default)
          }
        )
      },
      {
        id: 1,
        nlsid: 'decks.deck_1',
        cards: placeHolders(26),
        loaded: false,
        loader: (done) => require.ensure(['./decks/majs/majs'],
          (require) => {
            done(require('./decks/majs/majs').default)
          }
        )
      },

      {
        id: 2,
        nlsid: 'decks.deck_2',
        cards: placeHolders(32),
        loaded: false,
        loader: (done) => require.ensure(['./decks/animals/animals'],
          (require) => {
            done(require('./decks/animals/animals').default)
          }
        )
      },
      {
        id: 3,
        nlsid: 'decks.deck_3',
        cards: placeHolders(17),
        loaded: false,
        loader: (done) => require.ensure(['./decks/animals-animated/animals-animated'],
          (require) => {
            done(require('./decks/animals-animated/animals-animated').default)
          }
        )
      },
      {
        id: 4,
        nlsid: 'decks.deck_4',
        cards: placeHolders(16),
        loaded: false,
        loader: (done) => require.ensure(['./decks/food/food'],
          (require) => {
            done(require('./decks/food/food').default)
          }
        )
      },
      {
        id: 5,
        nlsid: 'decks.deck_5',
        cards: placeHolders(14),
        loaded: false,
        loader: (done) => require.ensure(['./decks/transportation/transportation'],
          (require) => {
            done(require('./decks/transportation/transportation').default)
          }
        )
      },
      {
        id: 6,
        nlsid: 'decks.deck_6',
        cards: placeHolders(26),
        loaded: false,
        loader: (done) => require.ensure(['./decks/mins/mins'],
          (require) => {
            done(require('./decks/mins/mins').default)
          }
        )
      },
      {
        id: 7,
        nlsid: 'decks.deck_7',
        cards: placeHolders(10),
        loaded: false,
        loader: (done) => require.ensure(['./decks/digits/digits'],
          (require) => {
            done(require('./decks/digits/digits').default)
          }
        )
      },
      {
        id: 8,
        nlsid: 'decks.deck_8',
        cards: placeHolders(21),
        loaded: false,
        loader: (done) => require.ensure(['./decks/music/music'],
          (require) => {
            done(require('./decks/music/music').default)
          }
        )
      },
      {
        id: 9,
        nlsid: 'decks.deck_9',
        cards: placeHolders(27),
        loaded: false,
        loader: (done) => require.ensure(['./decks/flags/flags'],
          (require) => {
            done(require('./decks/flags/flags').default)
          }
        )
      },
      {
        id: 10,
        nlsid: 'decks.deck_10',
        cards: placeHolders(22),
        loaded: false,
        loader: (done) => require.ensure(['./decks/kitchen/kitchen'],
          (require) => {
            done(require('./decks/kitchen/kitchen').default)
          }
        )
      },
      {
        id: 11,
        nlsid: 'decks.deck_11',
        cards: placeHolders(18),
        loaded: false,
        loader: (done) => require.ensure(['./decks/easter/easter'],
          (require) => {
            done(require('./decks/easter/easter').default)
          }
        )
      }
    ]
  }
  return decks
}

export default getDecks
